import { cloudflareLoader } from '@repo/web-utils/image-loader'

export default function imageLoader({
  src,
  width,
  quality,
}: {
  src: string
  width: number
  quality?: number
}) {
  return cloudflareLoader({ src, width, quality })
}
